<template>
  <router-view />
</template>

<script setup lang="ts">
// App.vue 作为路由容器
</script>

<style scoped>
/* 全局样式已在 style.css 中定义 */
</style>
